
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/wixData/components/emptyExternalDbItem/emptyExternalDbItem.scss.css.virtualfile';
        module.exports = {"emptyText":"_emptyText_1n6lv_1"};